module.exports = __webpack_public_path__ + "media/images/riders/JORDAN_SARROU-f65fa5e3a4c6c03940e8a92e8f785854.png";